export enum Steps {
  CreateInvestment,
  CompleteAllocation,
  RevalueInvestments,
  ApproveTransaction,
}
